module.exports = __webpack_public_path__ + "static/media/XIIh.144d4ea9.png";